module.exports = __webpack_public_path__ + "static/media/translate_icon.9f842cd7.svg";